module.exports = __webpack_public_path__ + "img/pub.7772dfb.png";